import styled from 'styled-components';
import { shouldForwardProp } from '@belong/themes';

export const TextInputUnstyled = styled.input.withConfig({
  shouldForwardProp: shouldForwardProp('width')
})`
  display: inline-block;
  border: none;
  border-radius: 0;
  padding: 0;
  width: 100%;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: inherit;
  line-height: normal;
  -webkit-appearance: none;
  text-decoration: none;
`;
